// src/lib/billingUtils.js

export const PLANS = [
  { limit: 1, id: "solo", title: "Starter", description: "1 борд", descriptionKey: "billing.plan_desc_solo", min: 1, max: 1, price: 30 },
  { limit: 5, id: "team", title: "Growth", description: "до 5 бордів", descriptionKey: "billing.plan_desc_team", min: 2, max: 5, price: 59 },
  { limit: 6, id: "scale", title: "Business", description: "6+ бордів", descriptionKey: "billing.plan_desc_scale", min: 6, max: Infinity, price: 99 },
];

export const getUkrainianDayWord = (number) => {
  const last = number % 10;
  const lastTwo = number % 100;

  if (lastTwo >= 11 && lastTwo <= 14) return "днів";
  if (last === 1) return "день";
  if (last >= 2 && last <= 4) return "дні";
  return "днів";
};

export function getPlanByLimit(planLimit) {
  const limit = Number(planLimit || 1);
  return PLANS.find((p) => p.limit === limit) || PLANS[0];
}

export function getRequiredPlanByBoardsCount(activeBoardsCount) {
  const count = Math.max(1, Number(activeBoardsCount || 0));

  return (
    PLANS.find((p) => count >= p.min && count <= p.max) ||
    PLANS[PLANS.length - 1]
  );
}

/**
 * Trial = безліміт (план 6+), незалежно від того, що записано в БД.
 * Повертає effective planLimit, який буде використаний у розрахунках.
 */
export function getEffectivePlanLimit(companyPlanLimit, paymentStatus) {
  if (paymentStatus === "trial") return 6;

  const n = Number(companyPlanLimit);
  if (!n || Number.isNaN(n)) return 1; // дефолт, якщо з БД прилетіло щось дивне/порожнє
  if (n === 1 || n === 5 || n === 6) return n;

  // на майбутнє: якщо раптом бек колись почне віддавати інші значення
  return 1;
}

/**
 * Головна функція для UI:
 * - бере поточний тариф компанії (planLimit з БД)
 * - якщо trial → effectiveLimit = 6
 * - рахує який план потрібен для поточної кількості бордів і для next
 * - каже чи треба апгрейд
 *
 * ВАЖЛИВО: третій параметр paymentStatus — опційний, щоб не ламати існуючі виклики.
 */
export function getPricingForBoards(activeBoardsCount, companyPlanLimit, paymentStatus) {
  const currentCount = Number(activeBoardsCount || 0);
  const nextCount = currentCount + 1;

  const effectiveLimit = getEffectivePlanLimit(companyPlanLimit, paymentStatus);

  const companyPlan = getPlanByLimit(effectiveLimit); // що вважаємо “планом компанії” для UI

  const requiredNow = getRequiredPlanByBoardsCount(currentCount);
  const requiredNext = getRequiredPlanByBoardsCount(nextCount);

  // Якщо компанія вже на 6+ (або trial => effectiveLimit=6) — апгрейд ніколи не потрібен
  const isUnlimited = Number(effectiveLimit) === 6;

  // Апгрейд потрібен тоді, коли requiredNext.limit > companyPlan.limit
  const willUpgradeOnNextBoard = !isUnlimited && requiredNext.limit > companyPlan.limit;

  return {
    currentCount,
    nextCount,

    // що зараз у компанії (в UI-логіці)
    companyPlan, // {limit, price, ...}

    // що треба, щоб підтримати поточну і наступну кількість бордів
    requiredNow,
    requiredNext,

    currentPrice: companyPlan.price,
    nextPlanPrice: requiredNext.price,

    nextPlanLimit: requiredNext.limit, // 1|5|6
    willUpgradeOnNextBoard,

    // інколи корисно мати явно:
    effectivePlanLimit: effectiveLimit,
  };
}